import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  topNavigation: [
    { id: "docs", label: "Início" },
    { id: "api", label: "Endpoints" },
  ],
  page: {
    logoUrl: "https://tabelafipeapi.com.br/wp-content/uploads/2023/04/fipe.png",
  },
  metadata: {
    title: "Tabela FIPE API",
    description: "API para consulta de preços de veículos na Tabela FIPE",
    favicon: "/public/icon.svg",
  },
  sidebar: {
    docs: [
      {
        type: "category",
        label: "Introdução",
        items: ["introduction"],
      },
    ],
  },
  redirects: [{ from: "/", to: "/docs/introduction" }],
  apis: {
    type: "file",
    input: "./apis/openapi.yaml",
    navigationId: "api",
  },
  docs: {
    files: "/pages/**/*.{md,mdx}",
  },
};

export default config;
